// extracted by mini-css-extract-plugin
export default {"blockStatistic":"ButtonLink_blockStatistic__XEzsw","btnStat":"ButtonLink_btnStat__7ufwZ","TgStatImg":"ButtonLink_TgStatImg__ffVx-","TelemetrImg":"ButtonLink_TelemetrImg__XFlaA"};